import { render } from "./downgrade.vue?vue&type=template&id=96364050&lang=pug"
import script from "./downgrade.vue?vue&type=script&lang=js"
export * from "./downgrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__